/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Badge_ChangeInputs */

const id_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan`)
};

const ms_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan`)
};

const da_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændring`)
};

const de_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderung`)
};

const en_us2_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change`)
};

const es_es2_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio`)
};

const es_mx2_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio`)
};

const fil_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagbabago`)
};

const fr_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changement`)
};

const it_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica`)
};

const hu_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változás`)
};

const nl_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijziging`)
};

const no_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endring`)
};

const pl_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiana`)
};

const pt_br2_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração`)
};

const pt_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração`)
};

const ro_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schimbare`)
};

const fi_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutos`)
};

const sv_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändring`)
};

const vi_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi`)
};

const tr_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik`)
};

const cs_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna`)
};

const bg_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промяна`)
};

const ru_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение`)
};

const uk_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зміна`)
};

const ar_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير`)
};

const hi_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तन`)
};

const th_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปลี่ยนแปลง`)
};

const ja_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更`)
};

const zh_cn2_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更改`)
};

const zh_hant1_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`變更`)
};

const ko_home_pulse_badge_change = /** @type {(inputs: Home_Pulse_Badge_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경`)
};

/**
* | output |
* | --- |
* | "Change" |
*
* @param {Home_Pulse_Badge_ChangeInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_badge_change = /** @type {((inputs?: Home_Pulse_Badge_ChangeInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Badge_ChangeInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_badge_change(inputs)
	if (locale === "ms") return ms_home_pulse_badge_change(inputs)
	if (locale === "da") return da_home_pulse_badge_change(inputs)
	if (locale === "de") return de_home_pulse_badge_change(inputs)
	if (locale === "en-US") return en_us2_home_pulse_badge_change(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_badge_change(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_badge_change(inputs)
	if (locale === "fil") return fil_home_pulse_badge_change(inputs)
	if (locale === "fr") return fr_home_pulse_badge_change(inputs)
	if (locale === "it") return it_home_pulse_badge_change(inputs)
	if (locale === "hu") return hu_home_pulse_badge_change(inputs)
	if (locale === "nl") return nl_home_pulse_badge_change(inputs)
	if (locale === "no") return no_home_pulse_badge_change(inputs)
	if (locale === "pl") return pl_home_pulse_badge_change(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_badge_change(inputs)
	if (locale === "pt") return pt_home_pulse_badge_change(inputs)
	if (locale === "ro") return ro_home_pulse_badge_change(inputs)
	if (locale === "fi") return fi_home_pulse_badge_change(inputs)
	if (locale === "sv") return sv_home_pulse_badge_change(inputs)
	if (locale === "vi") return vi_home_pulse_badge_change(inputs)
	if (locale === "tr") return tr_home_pulse_badge_change(inputs)
	if (locale === "cs") return cs_home_pulse_badge_change(inputs)
	if (locale === "bg") return bg_home_pulse_badge_change(inputs)
	if (locale === "ru") return ru_home_pulse_badge_change(inputs)
	if (locale === "uk") return uk_home_pulse_badge_change(inputs)
	if (locale === "ar") return ar_home_pulse_badge_change(inputs)
	if (locale === "hi") return hi_home_pulse_badge_change(inputs)
	if (locale === "th") return th_home_pulse_badge_change(inputs)
	if (locale === "ja") return ja_home_pulse_badge_change(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_badge_change(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_badge_change(inputs)
	return ko_home_pulse_badge_change(inputs)
});
export { home_pulse_badge_change as "home.pulse.badge.change" }